export default __webpack_public_path__ + "static/media/pdf-icon.1a08ef66.svg";